var render = function render(){var _vm=this,_c=_vm._self._c;return _c('MglMap',{attrs:{"accessToken":_vm.accessToken,"mapStyle":_vm.mapStyle,"center":_vm.coordinates,"zoom":15}},[_c('MglMarker',{attrs:{"coordinates":_vm.coordinates,"color":"blue"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }